import {EventType} from '../bpmn-js';
import EventBus from 'diagram-js/lib/core/EventBus';
import {CreationResult} from "@ispm-client/modules/bpmn-modeler/models/creation-result";
import {get} from 'lodash';
import {NodeType} from "@ispm/shared/bpmn-io/node-type";
import {TreatmentNodeUtils} from "@ispm/shared/bpmn-io/treatment-node-utils";
import CommandInterceptor from "diagram-js/lib/command/CommandInterceptor";

export class AfterParseCompleteBehavior {

  constructor(private eventBus: EventBus, private modeling, private elementRegistry) {
    this.eventBus.on(EventType.AFTER_PARSE_COMPLETE, event => {
      if (event.nodeType === NodeType.treatment) {
        this.setTreatmentNodeName(event.nodeCreationResult, event.nodeId);
      }else{
        this.modeling.updateProperties(this.elementRegistry.get(event.nodeId), {id: event.nodeId});
      }
    })
  }

  private setTreatmentNodeName(result: CreationResult, nodeId: any) {
    const node = this.elementRegistry.get(nodeId);
    if(!!node) {
      const treatmentPlans = get(result, 'data.treatmentPlans', []);
      const clinicalTrial = get(result, 'data.clinicalTrial', undefined);
      const treatmentPlanNodeName = TreatmentNodeUtils.createName(treatmentPlans, clinicalTrial);
      this.modeling.updateProperties(node, {name: treatmentPlanNodeName});
    }
  }

}

AfterParseCompleteBehavior.$inject = [...CommandInterceptor.$inject, 'modeling', 'elementRegistry'];
